// extracted by mini-css-extract-plugin
module.exports = {"legalLinksSectionColor":"LegalLinksBlock_legalLinksSectionColor__4MsY_","legalLinksBlock":"LegalLinksBlock_legalLinksBlock__CmKQD","legalLink":"LegalLinksBlock_legalLink__0rpX5"};